import React from "react"
import ContentLoader from "react-content-loader";

const EmailListing = (props) => {
    return(
        <ContentLoader
            height={250}
            width={'100%'}
            viewBox="0 0 100% 40"
            {...props}>
        <rect x="1" y="10" rx="5" ry="5" width="100%" height="50" />       
        <rect x="1" y="70" rx="5" ry="5" width="100%" height="50" />       
        <rect x="1" y="130" rx="5" ry="5" width="100%" height="50" />       
      </ContentLoader>
    )
}
EmailListing.metadata = {
    name: 'DaniloWoz',
    github: 'DaniloWoz',
    description: 'Simple Article',
    filename: 'EmailListing',
  }
export default EmailListing